export interface Contact {
  contactName: string;
  contactPhone: string;
}
